import React, { createContext, useState, useContext, useEffect } from "react";

// Create a context
const LanguageContext = createContext();

// Custom hook to use the language context
export const useLanguage = () => useContext(LanguageContext);

// Provider component to wrap the app
export const LanguageProvider = ({ children }) => {
  // Get language from localStorage (or default to English)
  const [language, setLanguage] = useState(localStorage.getItem("language") || "en");

  // Toggle between English and Arabic
  const toggleLanguage = () => {
    const newLang = language === "en" ? "ar" : "en";
    setLanguage(newLang);
    localStorage.setItem("language", newLang);
  };

  // Set the document direction when language changes
  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
